module.exports = __webpack_public_path__ + "img/AUTO_PHOTO_OUI.598ec48f.svg";